var $export = require(32);
$export($export.G + $export.W + $export.F * !require(113).ABV, {
  DataView: require(112).DataView
});